export default __webpack_public_path__ + "static/media/commissioning-en.9de0c134.png";